import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DecisionRolePageRoutingModule } from './decision-role-page-routing.module';
import { DecisionRolePageComponent } from './decision-role-page.component';
import { DecisionRolePageService } from './decision-role-page.service';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule } from 'devextreme-angular';
import { EditorModule } from 'primeng/editor';
import { DialogModule } from 'primeng/dialog';
import { PagesModule } from '@app/pages/pages.module';

@NgModule({
  declarations: [DecisionRolePageComponent],
  providers : [DecisionRolePageService],
  imports: [
    CommonModule,
    DecisionRolePageRoutingModule,
    MaterialUIModule,
    FormsModule,
    ReactiveFormsModule,
    PrimengModule,
     DialogModule,
    EditorModule,
    PagesModule,
    DxDataGridModule, DxButtonModule, DxPopupModule, DxTemplateModule
  ]
})
export class DecisionRolePageModule { }
